module.exports = __webpack_public_path__ + "media/images/mailer-new-survey-request-reminder-c3573d1649281cadcd511d448266937b.png";